import { Component } from '@angular/core';
import { WindowComponent } from "sharedFeatures/window";
import { DowngradePopupBodyComponent } from './downgrade-popup-body.component';

@Component(
    {
        selector: 'downgrade-popup',
        templateUrl: '../window/window.component.html',
        styleUrls: ['../window/window.component.less']
    })
export class DowngradePopup extends WindowComponent {

    width = 600;
    height = 515;

    showClose = false;

    loseFeaturesText = $localize`You are going to lose features!`;
    confirmDowngradeText = $localize`Please confirm downgrade`;

   /* title = this.loseFeaturesText;*/
    cornerRadius = 0;

    modal = true;

    topMargin = 0;

    dimOpacity = 0.7;

    windowContentBody = DowngradePopupBodyComponent;

    public onDowngrade: Function | undefined;    

    getBodyComponent(): DowngradePopupBodyComponent {

        return <DowngradePopupBodyComponent>super.getBodyComponent();

    }

    setDowngradeWithSameFeatures(useSameFeatures: boolean) {
        this.getBodyComponent().IsDowngradeWithSameFeatures = useSameFeatures;

        if (!useSameFeatures) {
            this.title = this.loseFeaturesText;            
            this.height = 270;
        }
        else {
            this.title = this.confirmDowngradeText;
            this.height = 230;
        }
    }

}